import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SwiperConfigInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-course-details-preview',
  templateUrl: './course-details-preview.component.html',
  styleUrls: ['./course-details-preview.component.scss']
})
export class CourseDetailsPreviewComponent implements OnInit {
  coursePreview: any;


  constructor(
    public dialogRef: MatDialogRef<CourseDetailsPreviewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private datePipe: DatePipe
  ) {

  }

  ngOnInit(): void {

    console.log('dataa----------------', this.data);
    // this.coursePreview = this.data;

    const fullAddress = this.data?.address ?? '';

    this.coursePreview = {
      ...this.data,
      startTime: this.convertTimeStringToDate(this.data?.startTime),
      endTime: this.convertTimeStringToDate(this.data?.endTime),
      city: ''
    };

    this.getCityFromGoogle(fullAddress).then(cityName => {
      this.coursePreview.city = cityName;
    });

  }
  closeDialog(): void {
    this.dialogRef.close();
  }
  earlybidPrice(coursePreview: any): boolean {
    if (!coursePreview?.early_bird_end_date) return false;

    // Convert both to "date-only" format (midnight)
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const endDate = new Date(coursePreview.early_bird_end_date);
    endDate.setHours(0, 0, 0, 0);


    // If end date is >= today → early bird still valid
    return endDate >= today;
  }
  get hasCourseData(): boolean {
    const preview = this.coursePreview;
    if (!preview) return false;

    return !!(
      preview.course_name ||
      preview.presented_by_name ||
      preview.startDate ||
      preview.cpd_points ||
      preview.type ||
      (preview.afterwards_price && preview.early_bird_price) ||
      (preview.course_banner_image?.length) ||
      preview.learning_objectives ||
      preview.description ||
      preview.event_type ||
      (preview.sponsor_by_image?.length) ||
      preview.terms ||
      preview.address ||
      preview.contact_email ||
      preview.contact_phone ||
      preview.contact_website
    );
  }

  // Hedaer banner  Video and Image
  headerBannerSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, // 
    speed: 800,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    loop: true
  };



  // event swiper 
  eventSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, // 
    speed: 800,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true
  };

  // Gallery swiper 
  gallerySwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, // 
    speed: 800,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true
  };

  // banner 
  bannerSwiperConfig: SwiperConfigInterface = {
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true }, // 
    speed: 800,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true
  };


  private convertTimeStringToDate(time?: string | null): Date | null {
    if (!time) {
      return null; // nothing to convert
    }
    const cleaned = time.replace(/\+.*/, '');      // remove +00 etc.
    return new Date(`1970-01-01T${cleaned}`);
  }

  get formattedDateRange(): string {
    const start = this.coursePreview?.startDate;
    const end = this.coursePreview?.endDate;

    if (!start || !end) return '';

    const s = new Date(start);
    const e = new Date(end);

    const day = this.datePipe.transform(s, 'd (EEE)')!;
    const month = this.datePipe.transform(s, 'MMMM')!;
    const year = this.datePipe.transform(s, 'yyyy')!;

    //  Same exact calendar day
    if (s.getFullYear() === e.getFullYear() &&
      s.getMonth() === e.getMonth() &&
      s.getDate() === e.getDate()) {
      return `${day} ${month} ${year}`;
    }

    // Same month & year
    if (
      this.datePipe.transform(s, 'MMMM') === this.datePipe.transform(e, 'MMMM') &&
      year === this.datePipe.transform(e, 'yyyy')
    ) {
      return `${day} – ${this.datePipe.transform(e, 'd (EEE)')} ${month} ${year}`;
    }

    // Same year, different month
    if (year === this.datePipe.transform(e, 'yyyy')) {
      return `${day} ${month} – ${this.datePipe.transform(e, 'd (EEE)')} ${this.datePipe.transform(e, 'MMMM')} ${year}`;
    }

    // Different year
    return `${day} ${month} ${year} – ${this.datePipe.transform(e, 'd (EEE)')} ${this.datePipe.transform(e, 'MMMM')} ${this.datePipe.transform(e, 'yyyy')}`;
  }

  private getCityFromGoogle(address: string): Promise<string> {
    return new Promise((resolve) => {
      const geoCoder = new google.maps.Geocoder();
      geoCoder.geocode({ address }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK && results?.length) {
          const components = results[0].address_components;
          // Try locality first
          const city =
            components.find(c => c.types.includes('locality'))?.long_name ||
            components.find(c => c.types.includes('postal_town'))?.long_name ||
            components.find(c => c.types.includes('administrative_area_level_2'))?.long_name ||
            '';
          resolve(city);
        } else {
          resolve(''); // fallback empty string
        }
      });
    });
  }

  get formattedRsvpDate(): string {
    const rsvp = this.coursePreview?.rsvp_date;
    if (!rsvp) return '';

    const d = new Date(rsvp);

    // Format: 30 (Tue) September 2025
    const day = this.datePipe.transform(d, 'd (EEE)')!;
    const month = this.datePipe.transform(d, 'MMMM')!;
    const year = this.datePipe.transform(d, 'yyyy')!;

    return `${day} ${month} ${year}`;
  }



}
